import { render, staticRenderFns } from "./edit-delivery-staff.vue?vue&type=template&id=24d5392c&scoped=true&"
import script from "./edit-delivery-staff.vue?vue&type=script&lang=js&"
export * from "./edit-delivery-staff.vue?vue&type=script&lang=js&"
import style0 from "./edit-delivery-staff.vue?vue&type=style&index=0&id=24d5392c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d5392c",
  null
  
)

export default component.exports